import { render, staticRenderFns } from "./ScrollBox.vue?vue&type=template&id=21e3c833&scoped=true"
import script from "./ScrollBox.vue?vue&type=script&lang=js"
export * from "./ScrollBox.vue?vue&type=script&lang=js"
import style0 from "./ScrollBox.vue?vue&type=style&index=0&id=21e3c833&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3c833",
  null
  
)

export default component.exports